{
	"actions": {
		"ban": "Banna utente",
		"delete": "Elimina account",
		"open_menu": "Apri menu azioni",
		"unban": "Sbanna utente",
		"view_detail": "Vedi dettaglio"
	},
	"ban_user": {
		"cancel": "Annulla",
		"confirm": "Banna utente",
		"description": "Banna {{email}} e revoca tutte le sessioni attive. Aggiungi una data di scadenza per rendere il ban temporaneo.",
		"expires_at": "Banna fino al",
		"expires_at_placeholder": "Seleziona una data",
		"reason": "Motivo",
		"reason_placeholder": "Motivo opzionale",
		"success": "Utente bannato.",
		"title": "Banna utente"
	},
	"columns": {
		"actions": "Azioni",
		"ban_expires": "Bannato fino a",
		"ban_permanent": "Ban permanente",
		"ban_reason": "Motivo ban",
		"ban_temporary": "Ban temporaneo",
		"email_verified": "Email verificata",
		"no_ban_reason": "Nessun motivo",
		"signup_source": "Origine registrazione",
		"status": "Stato"
	},
	"delete_user": {
		"cancel": "Annulla",
		"confirm": "Elimina account",
		"description": "Chiudi definitivamente {{email}}. L'utente non potrà più accedere, tutte le sessioni attive vengono terminate immediatamente e l'email viene liberata per il riutilizzo. L'operazione è irreversibile.",
		"reason": "Motivazione",
		"reason_placeholder": "Perché questo account viene eliminato?",
		"request_reference": "Riferimento richiesta (opzionale)",
		"request_reference_placeholder": "ID ticket di supporto o richiesta dati",
		"success": "Account eliminato.",
		"title": "Elimina account",
		"validation": {
			"reason_required": "La motivazione è obbligatoria.",
			"reason_too_long": "La motivazione può contenere al massimo 500 caratteri.",
			"reference_too_long": "Il riferimento può contenere al massimo 200 caratteri."
		}
	},
	"detail": {
		"account": {
			"title": "Account"
		},
		"breadcrumb": "Dettaglio utente",
		"sessions": {
			"columns": {
				"device": "Dispositivo",
				"expires_at": "Scadenza",
				"last_activity": "Ultima attività",
				"location": "Posizione",
				"source": "Creata con",
				"status": "Stato"
			},
			"empty": "Nessuna sessione trovata.",
			"source": {
				"email_otp": "OTP email"
			},
			"status": {
				"active": "Attiva",
				"expired": "Scaduta",
				"revoked": "Revocata"
			},
			"title": "Sessioni",
			"unknown_device": "Dispositivo sconosciuto"
		},
		"unknown_user": "Utente",
		"user_id": "ID utente"
	},
	"filters": {
		"field": {
			"created_at": "Data di creazione",
			"status": "Stato",
			"verified": "Email verificata"
		}
	},
	"page_title": "Utenti",
	"release_tax_code": {
		"confirm": "Libera il codice fiscale",
		"description": "Per chi non riesce a salvare il proprio codice fiscale perché un altro profilo lo occupa. Liberalo solo dopo aver visto il documento d'identità della persona. Il profilo che lo aveva torna incompleto e l'operazione resta nel registro.",
		"open": "Libera un codice fiscale",
		"reason": "Riferimento della verifica",
		"reason_placeholder": "Facoltativo, senza dati personali",
		"success": "Codice fiscale liberato.",
		"tax_code": "Codice fiscale",
		"title": "Libera un codice fiscale"
	},
	"search_placeholder": "Cerca utente...",
	"signup_source": {
		"email": "Email"
	},
	"unban_user": {
		"cancel": "Annulla",
		"confirm": "Sbanna utente",
		"description": "Rimuovi il ban per {{email}}.",
		"success": "Utente sbannato.",
		"title": "Sbanna utente"
	}
}
